import AbstractListStrategy from "./AbstractListStrategy.js";

/**
 * Strategy to render the items of a list source as cards. It provides
 * the architecture and the style for displaying card, and let the
 * card styling to the user.
 *
 * @param {Renderer} itemRenderer - Function taking one fetched item
 *   as argument and returning a Renderable for a card
 * @param {Renderable} [loadingCard] - Optional widget to display as
 *   card when loading
 */
export default class CardsStrategy extends AbstractListStrategy {
	constructor({ itemRenderer, loadingCard }) {
		super(...arguments);

		this._itemRenderer = itemRenderer;
		this._loadingCard = loadingCard;
		this._renderedItems = null;
	}

	baseCss() {
		return "cardListWidget";
	}

	renderLoadingOn(html) {
		if (!this._renderedItems || !this._loadingCard) {
			super.renderLoadingOn(html);
			return;
		}

		html.div(
			{ class: this.cssClass() },
			html.ul(
				{ class: "cards-container" },
				new Array(this._renderedItems.length).fill(
					this._renderLoadingCardOn.bind(this),
				),
				this._trailingCardRenderer({ disabled: true }),
			),
		);
	}

	itemsRenderer({ items }) {
		this._renderedItems = items;
		return (html) =>
			html.ul(
				{ class: "cards-container" },
				items.map((item, index) =>
					// this ping-pong is mandatory to allow wrapper to have a chance to intercept `makeItemRenderable`
					this._listSourceWidget.makeItemRenderable({
						html,
						item,
						index,
					}),
				),
				this._trailingCardRenderer(),
			);
	}

	makeItemRenderable({ html, item, index }) {
		return html.li(
			{ class: "card-container", "data-test": "card-item" },
			html.div(
				{ class: "card-content-container" },
				this._itemRenderer(item, index),
			),
		);
	}

	_renderLoadingCardOn(html) {
		html.li(
			{ class: "card-container" },
			html.div({ class: "card-content-container" }, this._loadingCard),
		);
	}

	_trailingCardRenderer({ disabled = false } = {}) {
		if (!this._trailingWidget) {
			return () => {};
		}

		return (html) => {
			html.li(
				{ class: "card-container" },
				html.div(
					{
						class: [
							"card-content-container",
							"trailing-card",
							{ disabled },
						],
						"data-test": "trailing-card-container",
					},
					this._trailingWidget,
					disabled
						? html.div({ class: "trailing-item-blocker" })
						: "",
				),
			);
		};
	}
}
